module.exports = __webpack_public_path__ + "img/img_03.dace05d2.jpg";